import { Component, OnInit, ChangeDetectorRef} from '@angular/core';
import { OrderService } from '@app/shared/services/order.service';
import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import { forkJoin, Subject, switchMap } from 'rxjs';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';

// Extend jsPDF to include lastAutoTable
declare module 'jspdf' {
  interface jsPDF {
    lastAutoTable: { finalY: number };
  }
}

@Component({
  selector: 'app-confrm-list',
  templateUrl: './confrm-list.component.html',
  styleUrls: ['./confrm-list.component.css']
})
export class ConfrmListComponent implements OnInit {

  orderList: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 15;
  searchText: string = '';
  fromDate: string = ''; // Start date for filtering
  toDate: string = '';   // End date for filtering
  orderId: string;
  private _totalItems: number = 0; // Keep track of total items after filtering
  FullOrderList: any[] = []; // Store the full list of confirmed orders
  selectedOrderType: string = ''; // Default to 'All' to show all orders by type
  clientName: string = '';
  refNo: string = '';
  page: number = 1;
  limit: number = 10;
  pageTotalItem: number = 0;
   private loadOrders$ = new Subject<void>();
  filteredData: any ={
    status: '',
    clientName: '',
    refNo: '',
    fromDate: '',
    toDate: '',
    ticketno:''
  } 
  constructor( private cdr: ChangeDetectorRef,
    private orderService: OrderService,
    private repeatOrderService: RepeatOrderService // Inject the RepeatOrderService

  ) {
  
  }



  ngOnInit(): void {   
    this.loadOrders$
        .pipe(
          // debounceTime(300),
          // distinctUntilChanged(),
          switchMap(() =>
            this.orderService.getConfirmOrders(this.page, this.limit, this.filteredData)
          )
        ).subscribe((res: any) => {
          this.FullOrderList = res.data;
          this.pageTotalItem = res.total;   

           // Unique ticket numbers
  this.ticketNumbers = [
    ...new Set(
      this.FullOrderList
        .map(order => order.ticketno)
        .filter(Boolean)
    )
  ];
  // 


          this.cdr.detectChanges();
        });
    
      this.loadOrders$.next(); 
    this.getAllOrder();   
  }

  formatDate(dateString: string): { date: string, time: string } {
    const date = new Date(dateString);
  
    // Format date: e.g., "Mar 1, 2025"
    const formattedDate = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  
    // Format time: hh:mm:ss AM/PM
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12; // Convert 0 to 12 for AM
    const formattedTime = `${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
  
    return {
      date: formattedDate,
      time: formattedTime
    };
  }
  
  
  
filterOrders() {
   if (this.fromDate && this.toDate) {
    this.filteredData['fromDate'] = this.fromDate;
    this.filteredData['toDate'] = this.toDate;
  }

  this.filteredData['status'] = this.selectedOrderType;  
  this.filteredData['refNo'] = this.refNo;
  this.filteredData['clientName'] = this.clientName;

   this.filteredData['ticketNo'] = this.searchTicket;

  this.page=1;
  this.getAllOrder();
}



clearFilters(): void {
  this.selectedOrderType = '';
  this.clientName = '';
  this.refNo = '';
  this.fromDate = '';
  this.toDate = '';
  this.searchTicket = '';

  this.filteredData = {
    status: '',
    clientName: '',
    refNo: '',
    fromDate: '',
    toDate: '',
    ticketNo: '',
  };

  this.page = 1;
  this.getAllOrder();
}

ticketNumbers: string[] = [];
searchTicket: string = '';




  getAllOrder() {
    this.loadOrders$.next();
    // this.orderService.getConfirmOrders(this.page, this.limit, this.filteredData).subscribe((res:any)=>{
    //   this.FullOrderList = res.data;
    //   this.pageTotalItem = res.total;
    //   this.cdr.detectChanges();
    // },(err:any)=>{
    //     console.log(err);
    // })

    // // Fetch orders from both services
    // const orderRequest = this.orderService.getOrder();
    // const repeatOrderRequest = this.repeatOrderService.getAllRepeatOrder();

    // forkJoin([orderRequest, repeatOrderRequest]).subscribe(
    //   ([orderRes, repeatOrderRes]: [any[], any[]]) => {
    //     this.FullOrderList = [...orderRes, ...repeatOrderRes].reverse(); // Combine both lists
    //     this.filterOrders(); // Apply filter and sort
    //     this.cdr.detectChanges();
    //   },
    //   (err: any) => {
    //     console.log(err);
    //   }
    // );
  }
  previewOrder(orderId: string) {
    // Fetch the order first to check its status
    this.orderService.getOrderById(orderId).subscribe(
      (order: any) => {
        console.log('Fetched order:', order);
        
        // If order is pending or confirmed, handle it
        if (order.status === 'Pending' || order.status === 'Confirmed') {
          this.openPrintWindow(this.prepareOrderDetails(order));
        }
      },
      (error) => {
        console.error('Error fetching order:', error);
      }
    );
  
    // Fetch repeated order if exists
    this.repeatOrderService.getRepeatOrderById(orderId).subscribe(
      (repeatedOrder: any) => {
        console.log('Fetched repeated order:', repeatedOrder);
        
        // If it's a repeated order, handle it
        if (repeatedOrder.status === 'Repeated Order') {
          this.openPrintWindow(this.prepareRepeatOrderDetails(repeatedOrder));
        }
      },
      (error) => {
        console.error('Error fetching repeated order:', error);
      }
    );
  }
  
  private prepareOrderDetails(order: any) {
    const materials = this.collectMaterials(order);
    return { ...order, materials }; // Add materials to order details
  }
  
  private prepareRepeatOrderDetails(repeatedOrder: any) {
    const materials = this.collectCombinedMaterials(repeatedOrder);
    return { ...repeatedOrder, materials }; // Add materials to repeated order details
  }
  
  private collectMaterials(order: any) {
    const materials = [];
    
    // Collect main materials
    if (order.sMat) {
      materials.push({ name: order.sMat, thickness: order.thickness, width: order.width });
    }
    
    // Collect additional materials from material1
    if (order.material1 && order.material1.length > 0) {
      order.material1.forEach(mat => {
        materials.push({ name: mat.sMat2, thickness: mat.thickness2, width: mat.width2 });
      });
    }
    
    // Collect additional materials from material2
    if (order.material2 && order.material2.length > 0) {
      order.material2.forEach(mat => {
        materials.push({ name: mat.sMat3, thickness: mat.thickness3, width: mat.width3 });
      });
    }
  
    return materials;
  }
  
  private collectCombinedMaterials(repeatedOrder: any) {
    return repeatedOrder.combinedMaterials.map(material => ({
      name: material.material,
      thickness: material.thickness,
      width: material.width
    }));
  }
  

  getNumber(value: any): number {
    if (!value) return 0;
    const num = parseFloat(value.toString().replace(/[^\d.-]/g, ''));
    return isNaN(num) ? 0 : num;
  }
  

  private openPrintWindow(order: any) {
    const doc = new jsPDF();
  
    const { time } = this.formatDate(order.created);
  
    doc.setFontSize(16);
    doc.text("New Order Confirmation Note", 105, 15, { align: 'center' });
  
    // Order Details
    autoTable(doc, {
      startY: 25,
      body: [
        // ['Client Name:', order.clientName, 'Order Status:', order.status],
        [{ content: 'Client Name:', styles: { fontStyle: 'bold',fontSize: 12.5, }  }, order.clientName, { content: 'Order Status:',styles: { fontStyle: 'bold',fontSize: 12.5, } }, order.status],

        [{ content: 'Ticket No:', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.ticketno, 
          { content: 'Order Timing:', styles: { fontStyle: 'bold', fontSize: 12.5 } }, time],
        [ { content: 'Ref No:', styles: { fontStyle: 'bold', fontSize: 12.5 } },{ content:order.refNo|| 'N/A', colSpan: 4 }],
        [ { content: 'PO No:', styles: { fontStyle: 'bold', fontSize: 12.5 } },{ content:order.poNo|| 'N/A', colSpan: 4 }],
        // ['Job Name:', order.jobName, '', ''],
        [ { content: 'Job Name:', styles: { fontStyle: 'bold', fontSize: 12.5 } },{ content: order.jobName || 'N/A', colSpan: 4 }],
        [ { content: 'Job Type:', styles: { fontStyle: 'bold', fontSize: 12.5 } },{ content: order.jobType|| 'N/A', colSpan: 4 }]
      ],
      theme: 'grid',
      styles: { fontSize: 12.5 },
      tableWidth: 180,

      columnStyles: {
        0: { cellWidth: 40 },
        1: { cellWidth: 50 },
        2: { cellWidth: 40 },
        3: { cellWidth: 50 }
      }
    });
  
    // Material Table
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 0,
      head: [['Standard Material Structure', 'Material Thickness(µ)', 'Material Width(mm)']],
      body: order.materials.map((m: any) => [
        m.name || 'N/A',
        m.thickness || 'N/A',
        m.width || 'N/A'
      ]),
      theme: 'grid',
      styles: { fontSize: 12.5 },
      tableWidth: 180,

      columnStyles: {
        0: { cellWidth: 80 },
        1: { cellWidth: 50 },
        2: { cellWidth: 50 }
      }
    });
  
    // Additional Fields
    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 0,
      body: [
        [
          { content: 'PO Received Date', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.poDate, 
          { content: 'PO No', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.poNo
      ],
      [
          { content: 'Coil OD', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.coilod, 
          { content: 'Coil Width', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.coilWidth
      ],
      [
          { content: 'Shade Remark', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.sRemrk, 
          { content: 'Barcode Number', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.barcode
      ],
      [
          { content: 'Remark', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.remark, '', ''
      ],
      [
          { content: 'Order Kgs', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.orderKgs, 
          { content: 'Order Pcs', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.orderPcs
      ],
      [
          { content: 'Final Direction', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.fdOption, '', ''
      ],
      [
          { content: 'Dispatch Type', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.dispatch, 
          { content: 'Packaging Type', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.packageType
      ],
      [
          { content: 'Delivery Date', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.ddDate, '', ''
      ],
      [
          { content: 'Prepared By', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.prepare || order.prepared, 
          { content: 'Approved By', styles: { fontStyle: 'bold', fontSize: 12.5 } }, order.approved
      ]
      
      ],
      theme: 'grid',
      styles: { fontSize: 12.5 },
      tableWidth: 180,
    });
    
  
    // ➤ Create blob and open in new tab
    const pdfBlob = doc.output('blob');
    const blobUrl = URL.createObjectURL(pdfBlob);
    window.open(blobUrl);
  }
  

  // get paginatedClients(): any[] {
  //   const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  //   const endIndex = startIndex + this.itemsPerPage;
  //   return this.orderList
  //     .filter((client) => this.matchesSearch(client))
  //     .slice(startIndex, endIndex);
  // }

  get paginatedOrders(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    return this.orderList
      .filter((client) => this.matchesSearch(client))
      .slice(startIndex, endIndex);
  }
  


  
  getNumberRange(end: number): number[] {
    return Array.from({ length: end }, (_, index) => index + 1);
  }
  
  ceil(value: number): number {
    return Math.ceil(value);
  }
  
  get totalItems(): number {
    return this.orderList.filter((client) => this.matchesSearch(client)).length;
  }
  
  calculateRangeStart(): number {
    return (this.page - 1) * this.limit + 1;
  }
  
  calculateRangeEnd(): number {
    return Math.min(this.page * this.limit, this.pageTotalItem);
  }

  
  
  onPageChange(page: number): void {
    // if (page >= 1 && page <= this.ceil(this.totalItems / this.itemsPerPage)) {
    //   this.currentPage = page;
    // }
    this.page = page;
    this.getAllOrder();
  }
  
  onSearch(): void {
    this.currentPage = 1; // Reset to the first page when performing a new search
  }
  

  private matchesSearch(client: any): boolean {
    const searchFields = ['clientName', 'email', 'contactNo'];
    const lowerCaseSearch = this.searchText.toLowerCase();

    return searchFields.some((field) => {
      const fieldValue = client[field];
      if (fieldValue && typeof fieldValue === 'string') {
        return fieldValue.toLowerCase().includes(lowerCaseSearch);
      }
      return false;
    });
  }

  deleteSelectedEntries() {
    const checkboxes = document.querySelectorAll('.rowCheckbox');
    const selectedIds = [];
    
    checkboxes.forEach((checkbox) => {
      if ((checkbox as HTMLInputElement).checked) {
        selectedIds.push((checkbox as HTMLInputElement).dataset.id); // Assuming dataset.id is used for ID
      }
    });

    if (selectedIds.length > 0) {
      this.orderService.deleteAllOrder(selectedIds).subscribe(
        (response) => {
          console.log('Entries deleted successfully:', response);
          // Optionally update your client list after deletion
          this.getAllOrder(); // Example method to fetch clients again
        },
        (error) => {
          console.error('Error deleting entries:', error);
          // Handle error in UI or show error message
        }
      );
    } else {
      console.log('No entries selected for deletion');
      // Handle case where no entries are selected
    }
  }

  selectAllChanged(event: Event) {
    const checkboxes = document.querySelectorAll('.rowCheckbox');
    checkboxes.forEach((checkbox) => {
      (checkbox as HTMLInputElement).checked = (event.target as HTMLInputElement).checked;
    });
  }

  downloadExcel(): void {
    this.orderService.getExportConfirmOrders(this.filteredData).subscribe((res:any)=>{
      const exportData = res.map((order:any) => ({
        Date: this.formatDate(order.created).date,
        TicketNo: order.ticketno,
        RefNo: order.refNo,
        PONo: order.poNo,
        ClientName: order.clientName,
        JobName: order.jobName,
        JobType: order.jobType,
        QtyKgs: order.orderKgs,
        QtyPcs: this.getNumber(order.orderPcs),
        DeliveryDate: order.ddDate,
        Status: order.status
      }));
    
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
      
  // foe setting width of the cells in excel sheet(by giving them characters to fit in)
      // 🔹 Set column widths
    worksheet['!cols'] = [
      { wch: 15 }, // Date
      { wch: 12 }, // TicketNo
      { wch: 12 }, // RefNo
      { wch: 12 }, // PONo
      { wch: 20 }, // ClientName
      { wch: 25 }, // JobName
      { wch: 15 }, // JobType
      { wch: 10 }, // QtyKgs
      { wch: 10 }, // QtyPcs
      { wch: 15 }, // DeliveryDate
      { wch: 15 }  // Status
    ];
    // wch = "width in characters"
    // 
      const workbook: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Confirmed Orders');
      XLSX.writeFile(workbook, 'confirmed-orders.xlsx');
    },(err:any)=>{
        console.log(err);
    });
  }
}










  
   // private openPrintWindow(order: any) {
  //   const printWindow = window.open('', '_blank');
  //   const materialRows = order.materials.map(material => `
  //     <tr>
  //       <td>${material.name}</td>
  //       <td>${material.thickness || 'N/A'}</td>
  //       <td colspan="2">${material.width || 'N/A'}</td>
  //     </tr>
  //   `).join('');
  //   const { time } = this.formatDate(order.created);

  //   if (printWindow) {
  //     const printContent = `
  //       <html>
  //       <head>
  //         <style>
  //           body { font-family: Arial, sans-serif; }
  //           .order-details { margin: 20px; }
  //           .order-details h1 { font-size: 24px; }
  //           .order-details table { border-collapse: collapse; width: 100%; }
  //           .order-details th, .order-details td { border: 1px solid #000; padding: 8px; }
  //           .order-details th { background-color: #f2f2f2; }
  //         </style>
  //       </head>
  //       <body>
  //         <div>
  //           <h3 style="text-align:center;">New Order Confirmation Note</h3>
  //         </div>
  //         <div class="order-details">
  //           <table>
  //             <tr><td><strong>Client Name:</strong></td><td>${order.clientName}</td>
  //             <td><strong>Order Status:</strong></td><td>${order.status}</td></tr>

  //             <tr><td><strong>Ticket No:</strong></td><td>${order.ticketno}</td>
  //             <td><strong>Order Timing:</strong></td><td>${time}</td></tr>
  //             <tr><td><strong>Ref No:</strong></td><td colspan="3">${order.refNo}</td></tr>
  //             <tr><td><strong>PO No:</strong></td><td colspan="3">${order.poNo}</td></tr>
  //             <tr><td><strong>Job Name:</strong></td><td colspan="3">${order.jobName}</td></tr>
  //             <tr><td><strong>Job Type:</strong></td><td colspan="3">${order.jobType}</td></tr>
  //             <tr>
  //               <th>Standard Material Structure</th>
  //               <th>Material Thickness(µ)</th>
  //               <th colspan="2">Material Width(mm)</th>
  //             </tr>
  //             ${materialRows}
  //             <tr>
  //               <th>PO Received Date</th>
  //               <td>${order.poDate}</td>
  //               <th>PO No</th>
  //               <td>${order.poNo}</td>
  //             </tr>
  //             <tr>
  //               <th>Coil OD</th>
  //               <td>${order.coilod}</td>
  //               <th>Coil Width</th>
  //               <td>${order.coilWidth}</td>
  //             </tr>
  //             <tr>
  //               <th>Shade Remark</th>
  //               <td>${order.sRemrk}</td>
  //               <th>Barcode Number</th>
  //               <td>${order.barcode}</td>
  //             </tr>
  //             <tr>
  //               <th>Remark</th>
  //               <td colspan="3">${order.remark}</td>
  //             </tr>
  //             <tr>
  //               <th>Order Kgs</th>
  //               <td>${order.orderKgs}</td>
  //               <th>Order Pcs</th>
  //               <td>${order.orderPcs}</td>
  //             </tr>
  //             <tr>
  //               <th>Final Direction</th>
  //               <td colspan="3">${order.fdOption}</td>
  //             </tr>
  //             <tr>
  //               <th>Dispatch Type</th>
  //               <td>${order.dispatch}</td>
  //               <th>Packaging Type</th>
  //               <td>${order.packageType}</td>
  //             </tr>
  //             <tr>
  //               <th>Delivery Date</th>
  //               <td colspan="3">${order.ddDate}</td>
  //             </tr>
  //             <tr>
  //               <th>Prepared By</th>
  //               <td>${order.prepare || order.prepared }</td>
  //               <th>Approved By</th>
  //               <td>${order.approved}</td>
  //             </tr>
  //           </table>
  //         </div>
  //         <script>
  //           window.print();
  //         </script>
  //       </body>
  //     `;
      
  //     printWindow.document.write(printContent);
  //     printWindow.focus();
  //     printWindow.print();
  //     printWindow.close();
  //   }
  // }
//   filterOrders() {
//     // Filter based on date range first
//     const filteredByDate = this.FullOrderList.filter(order => {
//         const orderDate = new Date(order.created);
//         const fromDateMatches = this.fromDate ? orderDate >= new Date(this.fromDate) : true;
//         const toDateMatches = this.toDate ? orderDate <= new Date(this.toDate) : true;
//         return fromDateMatches && toDateMatches;
//     });

//     // Filter by client name
//     const filteredByClientName = filteredByDate.filter(order => {
//         return this.clientName ? order.clientName.toLowerCase().includes(this.clientName.toLowerCase()) : true;
//     });

//     // Filter by reference number
//     const filteredByRefNo = filteredByClientName.filter(order => {
//         return this.refNo ? order.refNo.toLowerCase().includes(this.refNo.toLowerCase()) : true;
//     });

//     // Filter by selected order type
//     let filteredByOrderType = filteredByRefNo;
//     if (this.selectedOrderType === 'New Order') {
//         filteredByOrderType = filteredByRefNo.filter(order => {
//             return order.status === 'Pending' || order.status === 'Confirmed';
//         });
//     } else if (this.selectedOrderType === 'Repeated Order') {
//         filteredByOrderType = filteredByRefNo.filter(order => {
//             return order.status === 'Repeated Order';
//         });
//     }

//     // Filter by selected status
//     this.orderList = filteredByOrderType.filter(order => {
//         if (this.selectedOrderType === 'All') {
//             return true; // Show all if "All" is selected
//         }
//         return order.status === this.selectedOrderType;
//     });

//     // Sort the orders based on status order
//     this.orderList.sort((a, b) => {
//         const statusOrder = ['Pending', 'Confirmed', 'Repeated Order'];
//         return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
//     });

//     this._totalItems = this.orderList.length; // Update total items after filtering
// }

  // Method to format the date into 'DD-MM-YYYY'
  // formatDate(dateString: string): string {
  //   const date = new Date(dateString);
  //   const day = String(date.getDate()).padStart(2, '0');  // Ensure 2-digit day
  //   const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2-digit month
  //   const year = date.getFullYear(); // Full year
  //   return `${day}-${month}-${year}`;
  // }
  // formatDate(dateString: string): { date: string, time: string } {
  //   const date = new Date(dateString);
  
  //   // Format date: dd-mm-yyyy
  //   const day = String(date.getDate()).padStart(2, '0');
  //   const month = String(date.getMonth() + 1).padStart(2, '0');
  //   const year = date.getFullYear();
  //   const formattedDate = `${day}-${month}-${year}`;
  
  //   // Format time: hh:mm:ss AM/PM
  //   let hours = date.getHours();
  //   const minutes = String(date.getMinutes()).padStart(2, '0');
  //   const seconds = String(date.getSeconds()).padStart(2, '0');
  
  //   const ampm = hours >= 12 ? 'PM' : 'AM';
  //   hours = hours % 12 || 12; // Convert 0 to 12 for 12 AM
  //   const formattedTime = `${String(hours).padStart(2, '0')}:${minutes}:${seconds} ${ampm}`;
  
  //   return {
  //     date: formattedDate,
  //     time: formattedTime
  //   };
  // }
  // previewOrder(orderId: string) {
  //   // Fetch the order first to check its status
  //   this.orderService.getOrderById(orderId).subscribe(
  //     (order: any) => {
  //       // Log the order details for debugging
  //       console.log('Fetched order:', order);
    
  //       // Check the order status
  //       if (order.status === 'Pending' || order.status === 'Confirmed') {
  //         // Call the main order service only if the status is appropriate
  //         this.orderService.getOrderById(orderId).subscribe(
  //           (mainOrder: any) => {
  //             this.openPrintWindow(mainOrder);
  //           },
  //           (error) => {
  //             console.error('Error fetching main order:', error);
  //           }
  //         );
  //       } }
  //   );
  //   this.repeatOrderService.getRepeatOrderById(orderId).subscribe(
  //     (repeatedOrder: any) => {
  //       // Log the order details for debugging
  //       console.log('Fetched order:', repeatedOrder);
    
  //       // Check the order status
  //       if(repeatedOrder.status === 'Repeated Order') {
  //         // Call the main order service only if the status is appropriate
  //         this.repeatOrderService.getRepeatOrderById(orderId).subscribe(
  //           (mainOrder: any) => {
  //             this.openPrintWindow(mainOrder);
  //           },
  //           (error) => {
  //             console.error('Error fetching main order:', error);
  //           }
  //         );
  //       } }
  //   );
  // }
  

  // private openPrintWindow(order: any) {
  //   const printWindow = window.open('', '_blank');
  //  // Gather materials dynamically
  //  const materials = [];
  //  if (order.sMat) {
  //    materials.push({ name: order.sMat, thickness: order.thickness, width: order.width });
  //  }
  //  if (order.sMat2) {
  //    materials.push({ name: order.sMat2, thickness: order.thickness2, width: order.width2 });
  //  }
  //  if (order.sMat3) {
  //    materials.push({ name: order.sMat3, thickness: order.thickness3, width: order.width3 });
  //  }
 
  //  // Create material rows for the order
  //  let materialRows = materials.map(material => `
  //    <tr>
  //      <td>${material.name}</td>
  //      <td>${material.thickness || 'N/A'}</td>
  //      <td colspan="2">${material.width || 'N/A'}</td>
  //    </tr>
  //  `).join('');

  //   if (printWindow) {
  //     const printContent = `
  //       <html>
  //       <head>
  //         <style>
  //           body { font-family: Arial, sans-serif; }
  //           .order-details { margin: 20px; }
  //           .order-details h1 { font-size: 24px; }
  //           .order-details table { border-collapse: collapse; width: 100%; }
  //           .order-details th, .order-details td { border: 1px solid #000; padding: 8px; }
  //           .order-details th { background-color: #f2f2f2; }
  //         </style>
  //       </head>
  //       <body>
  //         <div>
  //           <h3 style="text-align:center;">New Order Confirmation Note</h3>
  //         </div>
  //         <div class="order-details">
  //           <table>
  //             <tr><td><strong>Client Name:</strong></td><td>${order.clientName}</td>
  //             <td><strong>Order Status:</strong></td><td>${order.status}</td></tr>
  //             <tr><td><strong>Ticket No:</strong></td><td colspan="3">${order.ticketno}</td></tr>
  //             <tr><td><strong>Ref No:</strong></td><td colspan="3">${order.refNo}</td></tr>
  //             <tr><td><strong>PO No:</strong></td><td colspan="3">${order.poNo}</td></tr>
  //             <tr><td><strong>Job Name:</strong></td><td colspan="3">${order.jobName}</td></tr>
  //             <tr><td><strong>Job Type:</strong></td><td colspan="3">${order.jobType}</td></tr>
  //             <tr>
  //               <th>Standard Material Structure</th>
  //               <th>Material Thickness(µ)</th>
  //               <th colspan="2">Material Width(mm)</th>
  //             </tr>
  //             ${materialRows} <!-- Dynamic material rows -->
  //             <tr>
  //               <th>PO Received Date</th>
  //               <td>${order.poDate}</td>
  //               <th>PO No</th>
  //               <td>${order.poNo}</td>
  //             </tr>
  //             <tr>
  //               <th>Coil OD</th>
  //               <td>${order.coilod}</td>
  //               <th>Coil Width</th>
  //               <td>${order.coilWidth}</td>
  //             </tr>
  //             <tr>
  //               <th>Shade Remark</th>
  //               <td>${order.sRemrk}</td>
  //               <th>Barcode Number</th>
  //               <td>${order.barcode}</td>
  //             </tr>
  //             <tr>
  //               <th>Remark</th>
  //               <td colspan="3">${order.remark}</td>
  //             </tr>
  //             <tr>
  //               <th>Order Kgs</th>
  //               <td>${order.orderKgs}</td>
  //               <th>Order Pcs</th>
  //               <td>${order.orderPcs}</td>
  //             </tr>
  //             <tr>
  //               <th>Final Direction</th>
  //               <td colspan="3">${order.fdOption}</td>
  //             </tr>
  //             <tr>
  //               <th>Dispatch Type</th>
  //               <td>${order.dispatch}</td>
  //               <th>Packaging Type</th>
  //               <td>${order.packageType}</td>
  //             </tr>
  //             <tr>
  //               <th>Date</th>
  //               <td colspan="3">${order.ddDate}</td>
  //             </tr>
  //             <tr>
  //               <th>Prepared By</th>
  //               <td>${order.prepare}</td>
  //               <th>Approved By</th>
  //               <td>${order.approved}</td>
  //             </tr>
  //           </table>
  //         </div>
  //         <script>
  //           window.print();
  //         </script>
  //       </body>
  //     </html>
  //   `;
  
  //     printWindow.document.write(printContent);
  //     printWindow.focus();
  //     printWindow.print();
  //     printWindow.close();
  //   }
  // }
  
  
  // private openPrintWindow(order: any) {
  //   const printWindow = window.open('', '_blank');
  
  //   // Gather materials dynamically
  //   const materials = [];
  //   if (order.sMat) {
  //     materials.push({ name: order.sMat, thickness: order.thickness, width: order.width });
  //   }
  //   if (order.sMat2) {
  //     materials.push({ name: order.sMat2, thickness: order.thickness2, width: order.width2 });
  //   }
  //   if (order.sMat3) {
  //     materials.push({ name: order.sMat3, thickness: order.thickness3, width: order.width3 });
  //   }
  
  //   // Create material rows for the order
  //   let materialRows = materials.map(material => `
  //     <tr>
  //       <td>${material.name}</td>
  //       <td>${material.thickness || 'N/A'}</td>
  //       <td colspan="2">${material.width || 'N/A'}</td>
  //     </tr>
  //   `).join('');
  
  //   printWindow.document.write(`
  //     <html>
  //       <head>
  //         <style>
  //           body { font-family: Arial, sans-serif; }
  //           .order-details { margin: 20px; }
  //           .order-details h1 { font-size: 24px; }
  //           .order-details table { border-collapse: collapse; width: 100%; }
  //           .order-details th, .order-details td { border: 1px solid #000; padding: 8px; }
  //           .order-details th { background-color: #f2f2f2; }
  //         </style>
  //       </head>
  //       <body>
  //         <div>
  //           <h3 style="text-align:center;">New Order Confirmation Note</h3>
  //         </div>
  //         <div class="order-details">
  //           <table>
  //             <tr><td><strong>Client Name:</strong></td><td>${order.clientName}</td>
  //             <td><strong>Order Status:</strong></td><td>${order.status}</td></tr>
  //             <tr><td><strong>Ticket No:</strong></td><td colspan="3">${order.ticketno}</td></tr>
  //             <tr><td><strong>Ref No:</strong></td><td colspan="3">${order.refNo}</td></tr>
  //             <tr><td><strong>PO No:</strong></td><td colspan="3">${order.poNo}</td></tr>
  //             <tr><td><strong>Job Name:</strong></td><td colspan="3">${order.jobName}</td></tr>
  //             <tr><td><strong>Job Type:</strong></td><td colspan="3">${order.jobType}</td></tr>
  //             <tr>
  //               <th>Standard Material Structure</th>
  //               <th>Material Thickness(µ)</th>
  //               <th colspan="2">Material Width(mm)</th>
  //             </tr>
  //             ${materialRows} <!-- Dynamic material rows -->
  //             <tr>
  //               <th>PO Received Date</th>
  //               <td>${order.poDate}</td>
  //               <th>PO No</th>
  //               <td>${order.poNo}</td>
  //             </tr>
  //             <tr>
  //               <th>Coil OD</th>
  //               <td>${order.coilod}</td>
  //               <th>Coil Width</th>
  //               <td>${order.coilWidth}</td>
  //             </tr>
  //             <tr>
  //               <th>Shade Remark</th>
  //               <td>${order.sRemrk}</td>
  //               <th>Barcode Number</th>
  //               <td>${order.barcode}</td>
  //             </tr>
  //             <tr>
  //               <th>Remark</th>
  //               <td colspan="3">${order.remark}</td>
  //             </tr>
  //             <tr>
  //               <th>Order Kgs</th>
  //               <td>${order.orderKgs}</td>
  //               <th>Order Pcs</th>
  //               <td>${order.orderPcs}</td>
  //             </tr>
  //             <tr>
  //               <th>Final Direction</th>
  //               <td colspan="3">${order.fdOption}</td>
  //             </tr>
  //             <tr>
  //               <th>Dispatch Type</th>
  //               <td>${order.dispatch}</td>
  //               <th>Packaging Type</th>
  //               <td>${order.packageType}</td>
  //             </tr>
  //             <tr>
  //               <th>Date</th>
  //               <td colspan="3">${order.ddDate}</td>
  //             </tr>
  //             <tr>
  //               <th>Prepared By</th>
  //               <td>${order.prepare}</td>
  //               <th>Approved By</th>
  //               <td>${order.approved}</td>
  //             </tr>
  //           </table>
  //         </div>
  //         <script>
  //           window.print();
  //         </script>
  //       </body>
  //     </html>
  //   `);
  //   printWindow.document.write(printContent);
  //   printWindow.document.close();
  //   printWindow.focus();
  //   printWindow.print();
  //   printWindow.close();
   
  // }
  

// previewOrder(orderId: string) {
 
//     const orderRequest = this.orderService.getOrderById(orderId);
//     const repeatOrderRequest = this.repeatOrderService.getRepeatOrderById(orderId);
  
//     forkJoin([orderRequest, repeatOrderRequest]).subscribe(([order, repeatedOrder]: [any, any]) => {
//       const printWindow = window.open('', '_blank');

//       // Gather materials dynamically
//       const materials = [];
//       if (order.sMat) {
//           materials.push({ name: order.sMat, thickness: order.thickness, width: order.width });
//       }
//       if (order.sMat2) {
//           materials.push({ name: order.sMat2, thickness: order.thickness2, width: order.width2 });
//       }
//       if (order.sMat3) {
//           materials.push({ name: order.sMat3, thickness: order.thickness3, width: order.width3 });
//       }

//       // Create material rows
//       let materialRows = materials.map(material => `
//           <tr>
//               <td>${material.name}</td>
//               <td>${material.thickness || 'N/A'}</td>
//               <td colspan="2">${material.width || 'N/A'}</td>
            
//           </tr>
//       `).join('');

//       printWindow.document.write(`
//           <html>
//               <head>
//                   <style>
//                       body { font-family: Arial, sans-serif; }
//                       .order-details { margin: 20px; }
//                       .order-details h1 { font-size: 24px; }
//                       .order-details table { border-collapse: collapse; width: 100%; }
//                       .order-details th, .order-details td { border: 1px solid #000; padding: 8px; }
//                       .order-details th { background-color: #f2f2f2; }
//                   </style>
//               </head>
//               <body>
//                   <div>
//                       <h3 style="text-align:center;">New Order Confirmation Note</h3>
//                   </div>
//                   <div class="order-details">
//                      <table>
//                          <tr><td><strong>Client Name:</strong></td><td>${order.clientName}</td>
//                          <td><strong>Order Status:</strong></td><td>${order.status}</td></tr>
//                          <tr><td><strong>Ticket No:</strong></td><td colspan="3">${order.ticketno}</td></tr>
//                          <tr><td><strong>Ref No:</strong></td><td colspan="3">${order.refNo}</td></tr>
//                          <tr><td><strong>PO No:</strong></td><td colspan="3">${order.poNo}</td></tr>
//                          <tr><td><strong>Job Name:</strong></td><td colspan="3">${order.jobName}</td></tr>
//                          <tr><td><strong>Job Type:</strong></td><td colspan="3">${order.jobType}</td></tr>
//                          <tr>
//                              <th>Standard Material Structure</th>
//                              <th>Material Thickness(µ)</th>
//                              <th colspan="2">Material Width(mm)</th>
                            
//                          </tr>
//                          ${materialRows} <!-- Dynamic material rows -->
//                          <tr>
//                              <th>PO Received Date</th>
//                              <td>${order.poDate}</td>
//                              <th>PO No</th>
//                              <td>${order.poNo}</td>
//                          </tr>
//                          <tr>
//                              <th>Coil OD</th>
//                              <td>${order.coilod}</td>
//                              <th>Coil Width</th>
//                              <td>${order.coilWidth}</td>
//                          </tr>
//                          <tr>
//                              <th>Shade Remark</th>
//                              <td>${order.sRemrk}</td>
//                              <th>Barcode Number</th>
//                              <td>${order.barcode}</td>
//                          </tr>
//                          <tr>
//                              <th>Remark</th>
//                              <td colspan="3">${order.remark}</td>
//                          </tr>
//                          <tr>
//                              <th>Order Kgs</th>
//                              <td>${order.orderKgs}</td>
//                              <th>Order Pcs</th>
//                              <td>${order.orderPcs}</td>
//                          </tr>
//                          <tr>
//                              <th>Final Direction</th>
//                              <td colspan="3">${order.fdOption}</td>
//                          </tr>
//                          <tr>
//                              <th>Dispatch Type</th>
//                              <td>${order.dispatch}</td>
//                              <th>Packaging Type</th>
//                              <td>${order.packageType}</td>
//                          </tr>
//                          <tr>
//                              <th>Date</th>
//                              <td colspan="3">${order.ddDate}</td>
//                          </tr>
//                          <tr>
//                              <th>Prepared By</th>
//                              <td>${order.prepare}</td>
//                              <th>Approved By</th>
//                              <td>${order.approved}</td>
//                          </tr>
//                      </table>
//                   </div>
//                   <script>
//                       window.print();
//                   </script>
//               </body>
//           </html>
//       `);
//       printWindow.document.close();
//   });
// }

// previewOrder(orderId: string) {
//   this.orderService.getOrderById(orderId).subscribe((order: any) => {
//       const printWindow = window.open('', '_blank');
//       printWindow.document.write(`
//           <html>
//               <head>
//                   <style>
//                       body { font-family: Arial, sans-serif; }
//                       .order-details { margin: 20px; }
//                       .order-details h1 { font-size: 24px; }
//                       .order-details table { border-collapse: collapse; width: 100%; }
//                       .order-details th, .order-details td { border: 1px solid #000; padding: 8px; }
//                       .order-details th { background-color: #f2f2f2; }
//                   </style>
//               </head>
//               <body>
//                   <div>
//                       <h3 style="text-align:center;">New Order Confirmation Note</h3>
//                   </div>
//                   <div class="order-details">
//                      <table>
//                       <tr><td><strong>Client Name:</strong></td><td>${order.clientName}</td>
//                       <td><strong>Order Status:</strong></td><td>${order.status}</td>
//                       </tr>

//                          <tr><td ><strong>Ticket No:</strong></td><td colspan="3">${order.ticketno}</td></tr>
//                          <tr><td><strong>Ref No:</strong></td><td colspan="3">${order.refNo}</td></tr>
//                          <tr><td><strong>PO No:</strong></td><td colspan="3">${order.poNo}</td></tr>
//                          <tr><td><strong>Job Name:</strong></td><td colspan="3">${order.jobName}</td></tr>
//                          <tr><td><strong>Job Type:</strong></td><td colspan="3">${order.jobType}</td></tr>

//                          <tr>
//                          <th>Standard Material Structure</th>
//                          <th>Material Thickness(µ)</th>
//                          <th>Material Width(mm)</th>
//                          <th>Process</th>
                         
//                          </tr>
//                          <tr>
//                          <td>Standard Material Structure</td>
//                          <td>Material Thickness(µ)</td>
//                          <td>Material Width(mm)</td>
//                          <td>Process</td>
                         
//                          </tr>
//                           <tr>
//                          <th>PO Received Date</th>
//                          <td>${order.poDate}</td>
//                          <th>PO No</th>
//                          <td>${order.poNo}</td>
            
//                          </tr>
//                            <tr>
//                          <th>Coil OD</th>
//                          <td>${order.coilod}</td>
//                          <th>Coil Width</th>
//                         <td>${order.coilWidth}</td>
            
//                          </tr>
//                            <tr>
//                          <th>Shade Remark</th>
//                        <td>${order.sRemrk}</td>

//                          <th>Barcode Number</th>
//                         <td>${order.barcode}</td>
            
//                          </tr>
//                          <tr>
//                          <th>Remark</th>
//                          <td colspan="3">${order.remark}</td>
                   
            
//                          </tr>
//                            <tr>
//                          <th>Order Kgs</th>
//                            <td>${order.orderKgs}</td>

//                          <th>Order Pcs</th>
//                            <td>${order.orderPcs}</td>

            
//                          </tr>
//                           <tr>
//                          <th>Final Direction</th>
//                          <td colspan="3">${order.fdOption}</td>
                   
            
//                          </tr>
//                           <tr>
//                          <th>Dispatch Type</th>
//                           <td>${order.dispatch}</td>

//                          <th>Packaging Type</th>
//                          <td>${order.packageType}</td>

            
//                          </tr>
//                            <tr>
//                          <th>Date</th>
//                          <td colspan="3">${order.ddDate}</td>

                   
            
//                          </tr>
//                            <tr>
//                          <th>Prepared By</th>
//                          <td>${order.prepare}</td>

//                          <th>Approved By</th>
//                           <td>${order.approved}</td>

            
//                          </tr>
                       
//                      </table>
//                   </div>
//                   <script>
//                       window.print();
//                   </script>
//               </body>
//           </html>
//       `);
//       printWindow.document.close();
      
//   });
// }











  
  

  // get paginatedClients(): any[] {
  //   const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  //   const endIndex = startIndex + this.itemsPerPage;
  //   return this.orderList
  //     .filter((client) => this.matchesSearch(client))
  //     .slice(startIndex, endIndex);
  // }
  // getNumberRange(end: number): number[] {
  //   return Array.from({ length: end }, (_, index) => index + 1);
  // }
  
  // ceil(value: number): number {
  //   return Math.ceil(value);
  // }
  

  // get totalItems(): number {
  //   return this.orderList.filter((client) => this.matchesSearch(client)).length;
  // }

  // calculateRangeStart(): number {
  //   return (this.currentPage - 1) * this.itemsPerPage + 1;
  // }

  // calculateRangeEnd(): number {
  //   return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
  // }

  // onPageChange(page: number): void {
  //   this.currentPage = page;
  // }

  

  // onSearch(): void {
  //   this.currentPage = 1; // Reset to the first page when performing a new search
  // }



  
